type Val = null | undefined | boolean | string;
type Arg = Val | Val[];

export const cx = (...args: Arg[]): string | undefined => {
  const list = args.flat().filter((arg) => arg && typeof arg === 'string');
  return list.length > 0 ? list.join(' ') : undefined;
};
